import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserControllerService } from '../services/user-controller.service';

/**
 * Decides where the root `/` route should land:
 *  - Terms not accepted → `/case` (preview with terms agreement)
 *  - Terms accepted     → `/case-list` (returning user)
 *
 * The incomplete-application dialog on `/case-list` handles the
 * draft-exists scenario separately.
 */
export const homeRedirectGuard: CanActivateFn = () => {
  const userService = inject(UserControllerService);
  const router = inject(Router);

  const user = userService.user?.();
  if (!user) return router.createUrlTree(['/401']);

  return user.termsAccepted
    ? router.createUrlTree(['/case-list'])
    : router.createUrlTree(['/case']);
};
